import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: '#1f2028' }}>
      {/* Header with navigation tabs and signup button */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: '#1f2028', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container-fluid px-3">
          <div className="d-flex align-items-center justify-content-between py-2" style={{ height: '48px' }}>
            <div>
              <Link to="/" className="text-decoration-none">
                <h5 className="text-light mb-0 fw-bold" style={{ fontSize: '1.1rem' }}>RE Calc</h5>
              </Link>
            </div>
            <div>
              <Link to="/features" className="btn btn-link text-light text-decoration-none">Features</Link>
              <Link to="/faqs" className="btn btn-link text-light text-decoration-none">FAQs</Link>
              <Link to="/contact" className="btn btn-link text-light text-decoration-none">Get in Touch</Link>
              <Link to="/pricing" className="btn btn-link text-light text-decoration-none">Pricing</Link>
              <Link to="/signup" className="btn btn-primary btn-sm ms-3">Ready to Start?</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="container py-5 flex-grow-1 d-flex flex-column justify-content-center">
        <div className="row align-items-center">
          <div className="col-md-6 mb-5 mb-md-0">
            <h1 className="display-4 fw-bold text-white mb-3">Real Estate Investment Calculator</h1>
            <p className="lead text-light mb-4">
              Analyze properties, calculate returns, and make data-driven investment decisions with our powerful real estate calculator.
            </p>
            <div className="d-flex gap-3">
              <Link to="/signup" className="btn btn-primary px-4 py-2">
                Create Free Account
              </Link>
              <Link to="/login" className="btn btn-outline-light px-4 py-2">
                Sign In
              </Link>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card bg-dark border-secondary">
              <div className="card-body p-4">
                <h5 className="text-white mb-3">Features</h5>
                <ul className="text-light">
                  <li className="mb-2">Property analysis with key metrics</li>
                  <li className="mb-2">Cash flow projections and ROI calculations</li>
                  <li className="mb-2">Scenario comparison tools</li>
                  <li className="mb-2">Customizable settings for accurate results</li>
                  <li>Investment portfolio tracking</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Feature Section */}
      <div className="container py-5 bg-dark" style={{ borderRadius: '12px', marginBottom: '2rem' }}>
        <h2 className="text-center text-white mb-5">How It Works</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="text-center px-3">
              <div className="mb-3">
                <i className="bi bi-house-add text-primary" style={{ fontSize: '2.5rem' }}></i>
              </div>
              <h5 className="text-white">Add Properties</h5>
              <p className="text-light">Enter property details including purchase price, rental income, and expenses.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-center px-3">
              <div className="mb-3">
                <i className="bi bi-calculator text-primary" style={{ fontSize: '2.5rem' }}></i>
              </div>
              <h5 className="text-white">Run Calculations</h5>
              <p className="text-light">Get instant analysis of cap rate, cash-on-cash return, and total ROI.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-center px-3">
              <div className="mb-3">
                <i className="bi bi-graph-up-arrow text-primary" style={{ fontSize: '2.5rem' }}></i>
              </div>
              <h5 className="text-white">Compare Scenarios</h5>
              <p className="text-light">Create multiple scenarios to find the best investment strategy.</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-4 mt-auto" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <p className="text-muted mb-0 small">© 2025 RE Calc. All rights reserved.</p>
            <div>
              <Link to="/login" className="text-muted me-3 small">Login</Link>
              <Link to="/signup" className="text-muted small">Sign Up</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
